import { Database, Cpu, ShieldCheck } from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
    {
        title: "Cloud Storage Solutions",
        description: "Efficient and scalable storage solutions designed to meet your data needs, ensuring security and accessibility at all times.",
        icon: Database,
    },
    {
        title: "Cloud Computing Power",
        description:
            "Leverage our robust computing resources to enhance your business operations with speed and reliability.",
        icon: Cpu,
    },
    {
        title: "Cloud Security Services",
        description:
            "Protect your data with our advanced security protocols, providing peace of mind and compliance with industry standards.",
        icon: ShieldCheck,
    }
];

export default function OtherServices() {
    return (
        <section className="container pb-24 pt-12">
            <div className="text-center">
                <h3 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Unlock the Future of Cloud Technology Today
                </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}